var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawEmailConsentJ36B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 664.388,
    height: 799.489,
    viewBox: "0 0 664.388 799.489",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(-480 -205.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7220-1255",
    "data-name": "Path 7220",
    d: "M382.334,87.652S370.675,64.335,373,43.359L334.2,63.465l1.5,38.171,46.633-13.984Z",
    transform: "translate(687.753 402.93)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1133",
    "data-name": "Ellipse 1133",
    cx: 35.005,
    cy: 35.005,
    r: 35.005,
    transform: "translate(1011 407.158)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7221-1256",
    "data-name": "Path 7221",
    d: "M384.574,434.407H363.208L353.05,352.019h31.524Z",
    transform: "translate(697.187 557.391)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7222-1257",
    "data-name": "Path 7222",
    d: "M325.63,414.636h0c-.66,1.125-1.02,4.741-1.02,6.032h0a7.242,7.242,0,0,0,7.247,7.247H398a4.956,4.956,0,0,0,4.951-4.951V420.2s3.271-8.282-3.466-18.47c0,0-8.372,7.982-20.886-4.516l-3.691-6.677L348.2,410.075l-14.809,1.815c-3.241.405-6.107-.06-7.772,2.746h.015Z",
    transform: "translate(682.954 576.667)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7224-1258",
    "data-name": "Path 7224",
    d: "M28.469,8.777H19.062S10.9,18.83,11.995,12.709,8.694,0,8.694,0L2.107,2.191S-11.067,57.6,28.469,60.647,76.8,32.934,76.8,32.934s-2.191-15.379-6.587-10.983-28.553,6.587-28.553,6.587L28.484,8.762l-.015.015Z",
    transform: "translate(1077.027 466.737) rotate(-166)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7225-1259",
    "data-name": "Path 7225",
    d: "M345.38,421.032l-20.541,5.792L292.67,350.316l30.339-8.567Z",
    transform: "translate(666.971 552.251)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7227-1260",
    "data-name": "Path 7227",
    d: "M458.765,175.1v84.429l-25.38,243.057H399.966l-7.805-180.265,3.646-77.362L317.62,363.258l41.132,125.306-35.279,4.167S257.588,344.068,266.05,331.569s84.264-159.93,84.264-159.93S458.735,177.445,458.765,175.1Z",
    transform: "translate(653.274 467.124)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7226-1261",
    "data-name": "Path 7226",
    d: "M280.81,419.729h0c-.33,1.26.315,4.831.66,6.092h0a7.247,7.247,0,0,0,8.943,5.011l63.648-17.975a4.958,4.958,0,0,0,3.421-6.107l-.75-2.656s.9-8.852-8.357-16.835c0,0-5.882,9.963-21.321,1.32l-5.371-5.432L301.291,409.2l-13.744,5.777c-3,1.26-5.9,1.605-6.737,4.756h0Z",
    transform: "translate(660.99 572.969)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7223-1262",
    "data-name": "Path 7223",
    d: "M341.274,76.318l51.3-8.1,39.641,21.6,2.326,167.445s-97.5,13.5-112.862-4.05-3.706-157.99-3.706-157.99l23.317-18.91h-.015Z",
    transform: "translate(677.513 415.37)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228-1263",
    "data-name": "Path 7228",
    d: "M415.855,111.729l11.268,18.455s15.935,62.628,0,62.883-48.1-31.914-48.1-31.914l4.2-16.79,11.658,4.666-2.326-37.3h23.3Z",
    transform: "translate(710.183 437.144)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7229-1264",
    "data-name": "Path 7229",
    d: "M380.26,80.728s37.3-6.572,40.8,17.84,5.447,47.548,5.447,47.548l-40.422,3.346L380.26,80.728h0Z",
    transform: "translate(710.803 421.227)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7251-1265",
    "data-name": "Path 7251",
    d: "M342.965,238.491l-52.636-44.854a3.074,3.074,0,0,1-.221-4.334L375.356,89.264a3.074,3.074,0,0,1,4.314-.47l52.636,44.854a3.074,3.074,0,0,1,.221,4.334L347.279,238.021A3.074,3.074,0,0,1,342.965,238.491Z",
    transform: "translate(665.296 425.326)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7252-1266",
    "data-name": "Path 7252",
    d: "M342.965,238.491l-52.636-44.854a3.074,3.074,0,0,1-.221-4.334L375.356,89.264a3.074,3.074,0,0,1,4.314-.47l52.636,44.854a3.074,3.074,0,0,1,.221,4.334L347.279,238.021A3.074,3.074,0,0,1,342.965,238.491Z",
    transform: "translate(665.296 425.326)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7253-1267",
    "data-name": "Path 7253",
    d: "M331,92.419,309.813,96.8s-56.626,31.164-45.913,42.972S320.076,153.1,320.076,153.1l9.393-14.539L318.1,133.231l28.838-23.782L331,92.419Z",
    transform: "translate(651.899 427.48)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7254-1268",
    "data-name": "Path 7254",
    d: "M373.387,95.149s-20.691-31.734-40.9-17.6-38.426,28.508-38.426,28.508l25.177,31.794,54.165-42.7h-.015Z",
    transform: "translate(667.666 418.224)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7264-1269",
    "data-name": "Path 7264",
    d: "M32.713,1.377c-9.547-3.514-20.6-.073-26.99,7.7A25.626,25.626,0,0,0,3.1,37.434a23.591,23.591,0,0,0,11.93,10.572,21.565,21.565,0,0,0,14.639.31A3.568,3.568,0,0,0,32.8,49a3.618,3.618,0,1,0-4.513-3.506,3.556,3.556,0,0,0,.043.424c-7.463,2.334-15.707-.533-20.7-6.593A22.782,22.782,0,0,1,4.991,15.135,22.426,22.426,0,0,1,24.823,2.7c8.659.028,16.852,5.742,18.582,14.467a15.829,15.829,0,0,1-3.152,12.859c-1.444,1.753-3.51,3.481-5.9,3.5a1.939,1.939,0,0,1-1.114-.455,5.006,5.006,0,0,1-1.89-4.594l.984-8.8a18.711,18.711,0,0,1,.741-4.2,1.506,1.506,0,0,0,.3-.732c.541-1.029,1.586-2.115,2.813-1.949a1.406,1.406,0,0,0,1.669-.947,1.365,1.365,0,0,0-.948-1.669,5.434,5.434,0,0,0-4.853,1.749,6.639,6.639,0,0,0-.725.964c-7.147-2.913-16.163-.17-19.832,6.86a13.065,13.065,0,0,0-.076,12.522c1.99,3.442,5.832,5.95,9.9,5.617A11.02,11.02,0,0,0,27.9,34.943a1.9,1.9,0,0,1,2.477-.08l.015.011a6.811,6.811,0,0,0,6.7.847c4.567-1.718,7.63-6.484,8.747-11.059C48.265,14.728,42.081,4.825,32.713,1.377Zm-10.3,31.907a6.337,6.337,0,0,1-7.235-3.617c-1.809-3.617-.626-12.4,5.77-14.521a13.426,13.426,0,0,1,9.329.245A16.134,16.134,0,0,0,29.9,17.3c-.511,3.706-1.53,11.494-1.6,11.737-.692,3.074-2.824,3.609-5.888,4.251Z",
    transform: "matrix(0.788, -0.616, 0.616, 0.788, 993.123, 584.622)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1137",
    "data-name": "Ellipse 1137",
    cx: 10.533,
    cy: 21.051,
    rx: 10.533,
    ry: 21.051,
    transform: "translate(964.562 582.221) rotate(-78.56)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1138",
    "data-name": "Ellipse 1138",
    cx: 10.533,
    cy: 21.051,
    rx: 10.533,
    ry: 21.051,
    transform: "translate(1058.76 580.407) rotate(-54.54)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(480 205.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7273-1270",
    "data-name": "Path 7273",
    d: "M610.34,713.215c-.17,0-.277,0-.314-.007l-299.264,0a17.63,17.63,0,0,1-16.4-24.16c10.858-27.129,25.478-92.215,1.4-223.322-28.435-154.814-2.978-210.764,9.287-227.634a17.707,17.707,0,0,1,14.28-7.27H623.278a17.634,17.634,0,0,1,16.961,22.517c-12.68,43.842-38.793,160.011-7.486,291.5,23.734,99.685,12.325,140.345-1.426,156.9C622.257,712.662,612.263,713.215,610.34,713.215ZM319.329,233.826a14.7,14.7,0,0,0-11.853,6.033c-12.037,16.557-36.988,71.656-8.762,225.328,23,125.246,11.847,191.475-1.563,224.979a14.385,14.385,0,0,0,1.466,13.6,14.649,14.649,0,0,0,12.145,6.443H610.1c.473.023,10.122.29,19.012-10.5,13.248-16.077,24.128-55.875.722-154.177-31.472-132.181-5.223-248.956,7.523-293.026a14.633,14.633,0,0,0-14.079-18.683Z",
    transform: "translate(-282.806 -230.825)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7274-1271",
    "data-name": "Path 7274",
    d: "M558.838,328.832H320.271a12,12,0,1,1,0-24.007H558.838a12,12,0,1,1,0,24.007Z",
    transform: "translate(-270.065 -193.794)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7275-1272",
    "data-name": "Path 7275",
    d: "M558.838,362.832H320.271a12,12,0,0,1,0-24.007H558.838a12,12,0,1,1,0,24.007Z",
    transform: "translate(-270.065 -176.779)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7279-1273",
    "data-name": "Path 7279",
    d: "M432.8,294.832H320.271a12,12,0,1,1,0-24.007H432.8a12,12,0,1,1,0,24.007Z",
    transform: "translate(-270.065 -210.808)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7280-1274",
    "data-name": "Path 7280",
    d: "M383.054,524.292c2.422-10.255,13.8-13.617,23.1-13.241a98.616,98.616,0,0,1,17.421,2.757c5.978,1.337,11.9,2.921,17.787,4.6,10.8,3.08,21.49,6.805,32.469,9.214,9.14,2,19.072,3.181,28.187.413,8.762-2.661,16.195-9.192,18.578-18.222,2.246-8.51-.838-17.814-9.084-21.7-7.52-3.546-17.018-1.743-20.746,6.277-4.2,9.043,0,18.9,6.651,25.448a74.525,74.525,0,0,0,12.36,9.388,46.027,46.027,0,0,0,14.8,6.629c8.68,1.854,19.02-.878,23.5-9.171a15.5,15.5,0,0,0,1.758-6.057c.265-2.884-4.238-2.865-4.5,0-.759,8.257-10.429,12.125-17.661,11.219a35.9,35.9,0,0,1-13.692-5.314,80.235,80.235,0,0,1-11.341-8c-6.133-5.308-11.883-14.043-7.764-22.325,3.354-6.744,12.1-6.677,17.417-2.328,6.441,5.268,5.292,14.828,1.044,21.084-4.7,6.926-13.229,9.83-21.267,10.143-8.734.34-17.4-1.664-25.742-4.034-10.372-2.945-20.64-6.242-31.062-9.014-5.917-1.574-11.879-2.995-17.9-4.1a59.082,59.082,0,0,0-17.359-1.2c-9.393,1.085-18.98,6.552-21.293,16.346-.665,2.817,3.674,4.019,4.341,1.2Z",
    transform: "translate(-282.403 -123.579)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1380",
    "data-name": "Rectangle 1380",
    transform: "translate(102.029 233.082)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.545,
    height: 70.52,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159.545,
    height: 69.52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1140",
    "data-name": "Ellipse 1140",
    cx: 20.829,
    cy: 20.829,
    r: 20.829,
    transform: "translate(161.472 247.513)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7294-1275",
    "data-name": "Path 7294",
    d: "M872.338,669.577h-7.245v-7.245a2.717,2.717,0,0,0-5.434,0v7.245h-7.245a2.717,2.717,0,0,0,0,5.434h7.245v7.245a2.717,2.717,0,1,0,5.434,0v-7.245h7.245a2.717,2.717,0,0,0,0-5.434Z",
    transform: "translate(-680.075 -403.952)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawEmailConsentJ36B);
export default __webpack_public_path__ + "static/media/undraw_email-consent_j36b.e05e9c9213d73065920a0cf17162007b.svg";
export { ForwardRef as ReactComponent };